var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m.004 186.622h118.152v325.373h-118.152z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.151 186.617v325.383h-20.603v-294.477h-97.548v-30.906z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.772 315.076h-25.384c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7h25.384c3.866 0 7 3.134 7 7v64.768c0 3.866-3.134 7-7 7z",
    fill: "#5f99d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.772 433.228h-25.384c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7h25.384c3.866 0 7 3.134 7 7v64.768c0 3.866-3.134 7-7 7z",
    fill: "#5f99d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.156 196.924h-118.152v-32.384c0-3.866 3.134-7 7-7h111.152l10 10.126v18.956z",
    fill: "#fedba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.509 157.535v39.384h-51.509v-32.384c0-3.866 3.134-7 7-7z",
    fill: "#fece85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.844 186.622h118.152v325.373h-118.152z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 186.617v30.906h-97.548v294.477h-20.604v-325.383z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.611 315.076h-25.384c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7h25.384c3.866 0 7 3.134 7 7v64.768c0 3.866-3.134 7-7 7z",
    fill: "#5f99d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.611 433.228h-25.384c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7h25.384c3.866 0 7 3.134 7 7v64.768c0 3.866-3.134 7-7 7z",
    fill: "#5f99d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.995 196.924h-118.151l-10-10.302v-18.956l10-10.126h111.152c3.866 0 7 3.134 7 7v32.384z",
    fill: "#fedba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.358 157.535v39.384h-51.51l-10-10.297v-18.955l10-10.132z",
    fill: "#fece85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.156 29.087h275.687v482.909h-275.687z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.848 29.082v30.905h-244.791v452.013h-30.906v-482.918z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.081 393.849v118.151h-118.162v-118.151l12.081-10h92.667z",
    fill: "#8ac9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.825 383.849v128.151h-30.906v-118.151l12.081-10z",
    fill: "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.768 393.844h-143.536c-3.866 0-7-3.134-7-7v-25.384c0-3.866 3.134-7 7-7h143.536c3.866 0 7 3.134 7 7v25.384c0 3.866-3.134 7-7 7z",
    fill: "#fedba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.741 354.465v39.384h-44.509c-3.866 0-7-3.134-7-7v-25.384c0-3.866 3.134-7 7-7z",
    fill: "#fece85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.536 39.388h-301.072c-3.866 0-7-3.134-7-7v-25.384c0-3.866 3.134-7 7-7h301.071c3.866 0 7 3.134 7 7v25.384c.001 3.866-3.133 7-6.999 7z",
    fill: "#fedba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.974 0v39.384h-44.509c-3.866 0-7-3.134-7-7v-25.384c0-3.866 3.134-7 7-7z",
    fill: "#fece85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.076 118.156h-25.384c-3.866 0-7-3.134-7-7v-25.384c0-3.866-3.134-7-7-7h-25.384c-3.866 0-7 3.134-7 7v25.384c0 3.866-3.134 7-7 7h-25.384c-3.866 0-7 3.134-7 7v25.384c0 3.866 3.134 7 7 7h25.384c3.866 0 7 3.134 7 7v25.384c0 3.866 3.134 7 7 7h25.384c3.866 0 7-3.134 7-7v-25.384c0-3.866 3.134-7 7-7h25.384c3.866 0 7-3.134 7-7v-25.384c0-3.866-3.134-7-7-7z",
    fill: "#f07281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.308 315.076h-64.768c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7h64.768c3.866 0 7 3.134 7 7v64.768c0 3.866-3.134 7-7 7z",
    fill: "#5f99d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.441 236.313v78.768h-23.905c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7z",
    fill: "#3c87d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.46 315.076h-64.768c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7h64.768c3.866 0 7 3.134 7 7v64.768c0 3.866-3.134 7-7 7z",
    fill: "#5f99d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.592 236.313v78.768h-23.906c-3.866 0-7-3.134-7-7v-64.768c0-3.866 3.134-7 7-7z",
    fill: "#3c87d0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m248.274 393.849h15.453v118.151h-15.453z",
    fill: "#eaf6ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.2ad998abc5962110c685fcae261f1b96.svg";
export { ForwardRef as ReactComponent };